import React from 'react';
import { useQuery } from '@apollo/client';
import styled from 'styled-components';

import OrderHistoryItem from './components/OrderHistoryItem';
import { Box, Hr } from 'core/ui/atoms';
import { isLoading } from 'core/api/loadingHelpers';
import Loading from 'core/ui/components/Loading';
import { LIST_PAID_SIGNATURE_PROGRAM_ORDERS } from 'core/api/apollo/queries';
import { NavigationHeader } from 'onramp/ui/components';

const OrderHistoryPage = () => {
  const { loading, error, data: { listPaidSignatureProgramOrders = {} } = {} } = useQuery(LIST_PAID_SIGNATURE_PROGRAM_ORDERS);

  if (isLoading(loading, listPaidSignatureProgramOrders, error)) {
    return <Loading />;
  }

  const RenderOrderHistory = () => {
    return listPaidSignatureProgramOrders.map((order) => (
      <OrderHistoryItem key={order.id} order={order} />
    ));
  };

  return (
    <Box>
      <NavigationHeader title='Order History' />
      <Hr />
      <Container>
        <RenderOrderHistory />
      </Container>
    </Box>
  );
};

const Container = styled(Box)`
  margin-top: 20px;
`;

export default OrderHistoryPage;
